module.exports = __webpack_public_path__ + "static/media/buy2.56370967.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/buy/buy2.png
// module id = 1651
// module chunks = 0